import { PublicTopbar as SharedPublicTopbar } from '@rockalingua/ui';

import Menu from './Menu/Menu';

export default function PublicTopbar() {
  return (
    <SharedPublicTopbar href="/">
      <Menu />
    </SharedPublicTopbar>
  );
}
